

<script>
/* eslint-disable no-empty */
/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Swal from "sweetalert2";

import DatePicker from "vue2-datepicker";
import Switches from "vue-switches";
import Multiselect from "vue-multiselect";
import HotelDatePicker from "vue-hotel-datepicker";
import NumberInputSpinner from "vue-number-input-spinner";
import moment from 'moment';
import { icons } from "../data-fontawesome";
import {
  urlMethods,
} from "@/state/helpers";

export default {
  page: {
    title: "Phiên bán hàng",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    HotelDatePicker,
    DatePicker,
    Switches,
    Multiselect,
    NumberInputSpinner
  },
  data() {
    return {
      title: "Phiên bán hàng",
      icons: icons,
      totalRows: 0,
      currentPage: 1,
      orderfilterOn: [],
      orders: [],
      posLists: [],
      orderFilter: null,
      startDate: moment().subtract(7, 'days').format("DD/MM/YYYY"),
      endDate: moment().format("DD/MM/YYYY"),
      isLoading: false,
      isCreateSession: false,
      dateRange: [new Date(moment().subtract(7, 'days').format("YYYY-MM-DD")), new Date()],
      posSelected: false,
      statusSelected: [{id: "all", name: 'Tất cả trạng thái'}],
      optionStatus: [
        {id: "all", name: 'Tất cả trạng thái'},
        {id: "opening_control", name: 'Mới'},
        {id: "opened", name: 'Đang mở bán'},
        {id: "closing_control", name: 'Đã đóng & Chưa vào sổ'},
        {id: "closed", name: 'Đã đóng & Vào sổ'},
      ],
      loadingArr: [],
      searchText: "",
      fields: [
        "id",
        {
          key: "pos_name",
          label: "Điểm bán lẻ"
        },
        {
          key: "name",
          label: "Mã phiên"
        },
        {
          key: "start_at",
          label: "Ngày mở"
        },
        {
          key: "stop_at",
          label: "Ngày đóng"
        },
        {
          key: "status",
          label: "Trạng thái"
        }
      ]
    };
  },
  computed: {
    currentUser() {
      let user = localStorage.getItem('currentUser') || false;
      return user ? JSON.parse(user) : false;
    },
    windowWidth(){
      return window.innerWidth;
    }
  },
  methods: {
    ...urlMethods,
    changeTimeRange(){
      this.startDate = moment(this.dateRange[0]).format('DD/MM/YYYY');
      this.endDate = moment(this.dateRange[1]).format('DD/MM/YYYY');
      this.currentPage = 1;
      this.getSessions();
    },
    searchSession(){
      this.currentPage = 1;
      this.getSessions();
      },
    changeStatus(){
      this.currentPage = 1;
      this.getSessions();
    },
    changePage(){
      this.getSessions();
    },
    async getSessionStep2(){
      let statusFilter = [];
      for(const stt of this.statusSelected){
        if(stt.id == 'all') statusFilter = ['all'];
        else if(!statusFilter.includes('all')){
          statusFilter.push(stt.id)
        }else{}
      }
      let body = {
        start: this.startDate, end: this.endDate, s: this.searchText,
        status: statusFilter, page: this.currentPage, posID: this.currentUser.pos_id
      };
      try {
        let res = await this.postUrl({'url' : 'sessions', 'data' : body});
        this.orders = res.data;
        this.totalRows = res.total;this.isLoading = false;
      } catch (error) {
        this.orders = [];
        this.totalRows = 0;
      this.isLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Lỗi...',
          text: error,
        });
      }
    },
    removeLoading(_id = 0){
      this.loadingArr = this.loadingArr.filter(function(item){return item != _id;});
    },
    loadingSession(id = 0){
      return this.loadingArr.includes(id);
    },
    async createSession(id = 0){
        this.isCreateSession = true;
        setTimeout(async () => {            
          try {
            let res = await this.postUrl({'url' : 'session/create', 'data' : {'id':this.posSelected}});
            if(typeof res.error != 'undefined' && res.error){
              throw res.message;
            }else{
              this.$bvModal.hide('modal-standard');
              this.getSessions();
            }
            this.isCreateSession = false;
          } catch (error) {
            this.isCreateSession = false;
            Swal.fire({
              icon: 'error',
              title: 'Lỗi...',
              text: error,
            });
          }
        }, 50);
    },
    async getSessions(){
      this.isLoading = true;
      setTimeout(async () => {
        await this.getSessionStep2()
      }, 50);
    },
    async getPos(){
      let that = this;
      setTimeout(async () => {
        that.posLists = [];
        try {
          let res = await that.getUrl('pos-list');
          that.posLists = res.data;
        } catch (error) {
          that.posLists = [];
        }
      }, 50);
    }
  },
  mounted() {
    this.getSessions();
    this.getPos();
  },
};
</script>

<template>
  <Layout>
        <div class="card">
          <div class="card-body pb-0">
      <div class="filter-box">
        <div class="filter-item">
          <div class="search-box me-2 mb-0 d-inline-block">
            <div class="position-relative">
              <input type="text" class="form-control" v-model="searchText" v-on:keyup.enter="searchSession" placeholder="Tìm kiếm..." />
              <i class="bx bx-search-alt search-icon"></i>
            </div>
          </div>
        </div>
        <div class="filter-item filter-daterange">
          <date-picker v-model="dateRange" range append-to-body lang="vn" confirm @change="changeTimeRange"></date-picker>
        </div>
        <div class="filter-item" style="min-width: 170px;">
          <multiselect :show-labels="false" v-model="statusSelected" label="name" track-by="id" placeholder="Trạng thái" @change="changeStatus" @input="changeStatus" @select="changeStatus" :options="optionStatus" :multiple="true"></multiselect>
        </div>
        <div class="filter-item" v-if="isLoading" style="display:flex;align-items:center;justify-content:center;flex-direction:column;"><i style="line-height: 1" class="fas fa-spinner fa-spin font-size-18"></i></div>
        
        <div class="filter-item filter-end">
          <div v-if="posLists.length > 0">          
          <b-button v-b-modal.modal-standard variant="primary">Mở phiên mới</b-button>
          <b-modal  hide-footer id="modal-standard" title="Chọn điểm bán lẻ để mở phiên" title-class="font-18">
            <div class="btn-group-vertical" role="group" style="width: 100%" aria-label="Vertical radio toggle button group">
              <div style="width: 100%; margin-bottom: 5px;" v-for="item in posLists" :key="item.id">
                <input type="radio" class="btn-check" v-model="posSelected" :id="'vbtn-radio'+item.id" :value="item.id" autocomplete="off" checked=""/>
                <label style="width: 100%; margin-bottom: 10px;" class="btn btn-outline-info mb-0" :for="'vbtn-radio'+item.id">{{item.name}}</label>
              </div>
            </div>
            <div class="text-right">
              <button @click="createSession" type="button" class="btn btn-primary"><i v-if="isCreateSession" class="fas fa-spinner fa-spin"></i> Xác nhận</button>
            </div>
          </b-modal>
          </div>
        </div>
        
      </div>
            <div class="table-responsive" style="padding: 0px 0px 15px" v-if="orders.length > 0">
             <b-table id="my-table" class="p-0 m-0 table-striped table-bordered" striped hover :items="orders" :fields="fields">
                <template v-slot:cell(id)="data">
                  <router-link :to="`/session/${data.item.id}`">{{ data.item.id }}</router-link>
                </template>
                <template v-slot:cell(name)="data">
                  <router-link :to="`/session/${data.item.id}`">{{ data.item.name }}</router-link>
                </template>
                <template v-slot:cell(status)="data">
                  <span :class="'badge font-size-12 bg-'+data.item.status_class">{{ data.item.status_name }}</span>
                </template>
              </b-table>
            </div>
            <div class="row" style="padding-bottom: 15px;" v-if="totalRows > 50">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination  aria-controls="my-table" @change="changePage" v-model="currentPage" :total-rows="totalRows" :per-page="50"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
    </div>
  </Layout>
</template>
